import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBInput, MDBView, MDBDataTable} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Input, Button ,Card   } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined, RightCircleOutlined, SearchOutlined } from '@ant-design/icons';

import Highlighter from 'react-highlight-words';
//import Modalteachingschedule from './Modalteachingschedule';
//import Modalcolor from './Modalcolor';
import { Table,   Space } from 'antd';
import { useReactToPrint } from 'react-to-print';
import jsPDF from 'jspdf';  
//import html2canvas from 'html2canvas';  

//import Table from '@material-ui/core/Table';  
import { CSVLink, CSVDownload } from "react-csv";
 import ReactExport from "react-export-excel";
//import Modelupdatetecher from './Modelupdatetecher';
import { api, URL } from '../../api';


//const ExcelFile = ReactExport.ExcelFile;
//const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
//const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

//import Button from '@material-ui/core/Button';  
    
////import React, { useRef } from "react"

export default class Certificase extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          thschedule:[],
          modal: false,
          term:'',
          type:'1',
          Studentcb_Citizen_ID:'',
          studentsearch:[],
         
      
          dd3:'',
          teacher:'',
         
          search: '',

          Showteather:[],
          Certificase:[],
          student: [],
          buttnoshow: false,
          pagination: {
            current: 1,
            pageSize: 20,
          },

        };
       
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.refreshPage = this.refreshPage.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.getstudent = this.getstudent.bind(this);
        
      }


    updateSearchDepartment(value) {
        // console.log(event.target.value)
        // const term = event.target.value;
        const term = value;
        this.setState({ term });
 
           setTimeout(() => {
             this.getthschedule()
           }, 500);
      }

      onTextChange = (e) => {

        this.setState({ [e.target.name]: e.target.value })
      }


      getthschedule() {
        setTimeout(() => {
           //ภายใน

            Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/getthschedule/'+this.state.term)
            .then(res => {
            //  console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
             this.setState({ thschedule: res.data})
             }) 


         }, 0);
      }


      getsearch() {


        Axios.get(`https://arit.kpru.ac.th/ap/survey/api.php?nu=reports&code=20210719&PostionType=%E0%B8%99%E0%B8%B1%E0%B8%81%E0%B8%A8%E0%B8%B6%E0%B8%81%E0%B8%A9%E0%B8%B2&id=${this.state.major}&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D&fbclid=IwAR37lj-5gXs9k55vAErqiHHH-Nyr5WKEzJIY_M_O_fsHzazOYbxbyZwusg4`,
           //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
             {headers: {
                // Authorization: 'Bearer ' + localStorage.getItem('myData')
             }
             })
           //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
             .then(res => {
            // console.log(res.data[0].id)
                // console.log(res.data)
             
                //   console.log(ppp)
              //  const student = res.data.filter( ({ citizen_id }) => citizen_id.substring(0, 7) === this.state.major );
                const student = res.data;
                 this.setState({ student });
                 this.setState({ buttnoshow : true});
                
             })
       }



      getstudent() {
        api.get('index/studentsearch/'+this.state.Studentcb_Citizen_ID,
          //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
            {headers: {
               // Authorization: 'Bearer ' + localStorage.getItem('myData')
            }
            })
          //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
            .then(res => {
            //    console.log(res.data[0].id)
                console.log(res.data)
            
               //   console.log(ppp)
             //  const student = res.data.filter( ({ citizen_id }) => citizen_id.substring(0, 7) === this.state.major );
                const studentsearch = res.data;
                 this.setState({ studentsearch });
              //   this.setState({ major:'' });
            })
      }



      sentpdf() {
        setTimeout(() => {
          window.open('https://e-student.kpru.ac.th/vaccinekpru/vaccinepdf/report/tess.php?stu='+this.state.major+'', '_blank');
           // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
         }, 0);
      }

    

   
     resetdata= e =>{
      console.log(e.target.value);
        // const idemp = value;
         this.setState({ major:'' });

     }


         onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          refreshPage() {
            window.location.reload(false);
          }




          componentDidMount(){
           

              if (localStorage.getItem('name') == null) {
               
                  window.location.href = 'https://e-student.kpru.ac.th/creditbank'
               
            } else {
        
            }
          //  api.get('index/getCertificasenall',
             Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getCertificasenall`,
            //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                    {headers: {
                    // Authorization: 'Bearer ' + localStorage.getItem('myData')
                    }
                    })
                    //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                    .then(res => {
                    // console.log(res.data[0].id)
                    //  console.log(res.data)
                    //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                    //  console.log(Course)
                        const Certificase = res.data;
                        this.setState({ Certificase });
                    }) 


                     
          }


          getColumnSearchProps = dataIndex => ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters , filters}) => (
              <div style={{ padding: 8 }}>
                <Input
                  ref={node => {
                    this.searchInput = node;
                  }}
                  placeholder={`ค้นหา`}
                  value={selectedKeys[0]}
                  onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                  onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                  style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                  type="primary"
                  onClick={() => this.handleSearch(selectedKeys, confirm)}
                  icon=""
                  size="small"
                  style={{ width: 90, marginRight: 8 }}
                >
                  ค้นหา
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  ยกเลิก
                </Button>
              </div>
            ),
            filterIcon: filtered => (
              <SearchOutlined />
        
            ),
        
            onFilter: (value, record) =>
              record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => this.searchInput.select());
              }
            },
        
            
            render: text => (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text.toString()}
              />
            ),
          });
        
          handleSearch = (selectedKeys, confirm) => {
            confirm();
            this.setState({ searchText: selectedKeys[0] });
          };
        
          handleReset = clearFilters => {
            clearFilters();
            this.setState({ searchText: '' });
          };
                
          clearFilters = () => {
            this.setState({ filteredInfo: null });
          };
        
        
          clearAll = () => {
            this.setState({
              filteredInfo: null,
              sortedInfo: null,
            });
          };



    render() {

      //  console.log(this.state.Showteather)

      let { sortedInfo, filteredInfo } = this.state;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const {  pagination } = this.state;
      const {linkcer} = "https://e-student.kpru.ac.th/creditbank/creditbankpdf/TCPDF-main/certificate/";
      const {pdf} = ".pdf";
     
      const columns = [

        {
            title: 'คำนำหน้า',
            dataIndex: 'FULLNAME',
            key: 'FULLNAME',
         //   responsive: ["sm"],
            ...this.getColumnSearchProps('FULLNAME'),
            render: (text, record) => (<><p>{record.FULLNAME}</p></> )
        },
        {
          title: 'ชื่อ',
          dataIndex: 'Studentcb_NAME',
          key: 'Studentcb_NAME',
          ...this.getColumnSearchProps('Studentcb_NAME'),
           render: (text, record) => (<><p>{record.Studentcb_NAME}</p></> )
        },
        {
            title: 'นามสกุล',
            dataIndex: 'Studentcb_LASTNAME',
            key: 'Studentcb_LASTNAME',
            ...this.getColumnSearchProps('Studentcb_LASTNAME'),
            render: (text, record) => (<><p>{record.Studentcb_LASTNAME}</p>
   
        </> )
           // render: text => <a>{text}</a>,
        },
        {
            title: 'เกรด',
            dataIndex: 'Studentcb_GRADE',
            key: 'Studentcb_GRADE',
            ...this.getColumnSearchProps('Studentcb_GRADE'),
            render: (text, record) => (<><p>{record.Studentcb_GRADE}</p> 
        </> )
           // render: text => <a>{text}</a>,
        },
        {
          title: 'รหัสเกียรติบัตร',
          dataIndex: 'Studentcb_Code_Certificate',
          key: 'Studentcb_Code_Certificate',
          ...this.getColumnSearchProps('Studentcb_Code_Certificate'),
          render: (text, record) => (<><p>{record.Studentcb_Code_Certificate}</p> 
      </> )
         // render: text => <a>{text}</a>,
      },
      {
        title: 'แสดงเกียรติบัตร',
        dataIndex: 'Studentcb_Code_Certificate',
        key: 'Studentcb_Code_Certificate',
        ...this.getColumnSearchProps('Studentcb_Code_Certificate'),
        
        render: (text, record) => (<>  <a href={"https://e-student.kpru.ac.th/creditbank/creditbankpdf/TCPDF-main/certificate/"+record.Studentcb_Code_Certificate+".pdf"} target="_blank">Certificate</a> 
    </> )
       // render: text => <a>{text}</a>,
    },
    {
        title: 'อัพเดทเกียรติบัตร',
        dataIndex: 'Studentcb_Code_Certificate',
        key: 'Studentcb_Code_Certificate',
        ...this.getColumnSearchProps('Studentcb_Code_Certificate'),
        
        render: (text, record) => (<>  <a href={"https://e-student.kpru.ac.th/creditbank/creditbankpdf/TCPDF-main/certificatecreditbankedit.php?idci="+record.Studentcb_Citizen_ID+"&idculi="+record.Curriculumopen_ID+"&faculty="+record.Curriculumopen_faculty} target="_blank">UPDATECertificate</a> 
    </> )
       // render: text => <a>{text}</a>,
    },
        
      ];

     // const ppp = this.state.Showteather.filter( ({ Teacher_PNAME }) => Teacher_PNAME.substring(0, 7) === '6411202' );
 
        const { Option } = Select;
    //  const studentsa =  this.state.student.map(showteachingschedule => { 
    //   [  { firstname: showteachingschedule.citizen_id, lastname: showteachingschedule.citizen_id, email: showteachingschedule.citizen_id } ] 
    //   }  )     
        return (
            <MDBContainer fluid>
              
        {/* <CSVLink data={data}>Download EXCEL</CSVLink> */}
       <Card type="inner" style={{ marginTop: 16 }}  title={<h4><MDBIcon icon="certificate" /> แก้ไขข้อมูลเกียรติบัตร</h4> } extra={<a href="#"><p>คุณ{localStorage.getItem('name')}</p></a>} >
                {/* <div className="form-group">
                <label htmlFor="example2"><MDBIcon icon="search" /> ค้นหา </label><br/>
                <Input placeholder="เลขประจำตัวประชาชน 13 หลัก"  style={{ width: 300 }} value={this.state.Studentcb_Citizen_ID} name="Studentcb_Citizen_ID" onChange={this.onTextChange} required  /><Button type="primary" onClick={this.getstudent}>ค้นหา</Button>
                </div> */}
        <MDBJumbotron className="p-4" >
                  <h2 className="display-5 deep-purple-text text-center">ข้อมูลเกียรติบัตร </h2>
                  <MDBRow>
                  {/* <Modelupdatetecher/>   */}
                          <MDBCol sm="12">
                            <br/> 
                            {/* <p>พบทั้งหมด {this.state.studentsearch.length} รายการ</p> */}
                            <Table  columns={columns} dataSource={this.state.Certificase}    />     
                          </MDBCol>
                </MDBRow>
        </MDBJumbotron>
        </Card>

                    {/* <Card title="Card title">
                        <Card type="inner" title="Inner Card title" extra={<a href="#">More</a>}>
                        Inner Card content
                        </Card>
                        <Card
                        style={{ marginTop: 16 }}
                        type="inner"
                        title="Inner Card title"
                        extra={<a href="#">More</a>}
                        >
                        Inner Card content
                        </Card>
                   </Card> */}
            </MDBContainer>
        )
    }
}
